import React, { Component } from 'react';
import Footer from '../Footer/Footer';
import PostGrid from './PostGrid';
import CarouselRefined from './elements/CarouselRefined';
import { Link } from 'react-router-dom'
import { removeSpacing, applyPageBackground } from '../utils/utils.js'
import { PostTag } from './styles/index'

class PostFull extends Component {
  static defaultProps = {
    postContent: {
      title: "",
      content: [],
      subHeader: '',
      theImages: []
    }
  }

  componentDidMount() {
    this.applyBackground();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.postContent !== this.props.postContent) {
      this.applyBackground();
    }
  }

  applyBackground = () => {
    const fields = (this.props.postContent && this.props.postContent.fields) || {};
    const hasColor = fields.colorfulBackground === true && typeof fields.backgroundColor === 'string' && fields.backgroundColor.trim();
    applyPageBackground(hasColor ? fields.backgroundColor : '#101010');
  }

  render() {
    let post = this.props.postContent.fields;
    let sub, carousel;
    carousel = post.carouselContent ? post.carouselContent : 'NOT A CAROUSEL';
    post.subHeader === undefined ? sub = "" : sub = <div><h3>{post.subHeader}</h3></div>;
    const postStyles = {
      backgroundColor: post.colorfulBackground ? post.backgroundColor : ''
    }
    return (
      <div className="App project-full" style={postStyles}>
        <main>
          {!post.carouselContent &&

            <div className="post__header">
              <div>
                <h2>{post.title}</h2>
                <div className="thumb">
                  <img
                    alt={post.thumbnail.fields.file.url}
                    src={post.thumbnail.fields.file.url} />
                </div>
              </div>
              {sub}
            </div>
          }
          <div className="spacer__small"></div>
          <section>
            {post.carouselContent &&
              <CarouselRefined
                postContent={this.props.postContent}
                next={this.props.nextPost}
                updateLocation={this.props.updateLocation}
              >
                {carousel}
              </CarouselRefined>
            }
            {!post.carouselContent &&
              <PostGrid postImages={post.media} postContent={post.content} />
            }
          </section>
          {!post.carouselContent &&
            <footer>
              <h5> next project</h5>
              <Link to={`${removeSpacing(this.props.nextPost ? '/project/' + this.props.nextPost.fields.title : '')}`}>
                <h3>{this.props.nextPost ? this.props.nextPost.fields.title : 'Return Home'}</h3>
              </Link>
            </footer>
          }
        </main>
        {!post.carouselContent &&
          <PostTag style={{ fontFamily: 'newFont, Sackers, sans-serif' }}>{this.props.footerText}</PostTag>
        }
        <Footer />
      </div>
    );
  }
}

export default PostFull;
